<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h2 class="sp-color__accent">Onboarding steps</h2>

    <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__top-x2" />
    <div class="sp-row__space sp-margin__top">
      <h3
        class="sp-color__primary sp-margin__right"
        style="white-space: nowrap">
        {{ buyer?.origin?.replace('_', ' ') || '-' | uppercase }}
      </h3>
      <p
        *ngIf="buyer?.origin_store_name"
        class="sp-color__primary sp-text__ellipsized sp-text__right sp-padding__right">
        <i> {{ buyer?.origin_store_name || '-' }} </i>
      </p>
    </div>

    <div class="sp-row__space sp-margin__top">
      <p
        class="sp-color__primary sp-margin__right"
        style="white-space: nowrap">
        <b>{{ 'GENERAL.COMPANY_LABEL' | translate }}</b>
      </p>
      <p class="sp-color__primary sp-text__right sp-padding__right">
        <i> {{ buyer?.origin_company_name || '-' }} </i>
      </p>
    </div>
    <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__bottom-x2" />

    <p
      *ngFor="let step of getOnboardingSteps()"
      class="sp-margin__top sp-color__primary">
      {{ step[0] }}: {{ step[1] | date : 'short' }}
    </p>
  </div>
</div>
